import { api, ApiRes } from './_api-client';

export enum ObjectType {
  Project,
  Story,
  FinalCut,
  MediaFile,
  Clip,
  FinalCutClip,
  AudioTrack,
  FinalCutAudioTrack,
}

export enum AccessType {
  Unrestricted,
  Protected,
  Locked,
}

export interface UpdateAccessType {
  objectId: ProjectId | StoryId | FinalcutId;
  objectType: ObjectType;
  accessType: AccessType;
}

// S E R V I C E

export const updateAccessType = async ({ objectId, objectType, accessType }: UpdateAccessType) => {
  return api.patch<ApiRes>(
    `/Access/UpdateAccessType?objectId=${objectId}&objectType=${objectType}&accessType=${accessType}`
  );
};
